import { AuthenticatedUser, Organization } from "@biggeo/bg-server-lib/studio";
import {
    CellItem,
    CompanyAvatar,
    Radio,
    Stack,
    Typography,
    AuthedHeaderAccountMenu,
} from "@biggeo/bg-ui/lab";

import { unwrapMaybe } from "../common/utils/helpers";
import { useLogout } from "../user/redux/hooks";

interface IAccountMenu {
    readonly user: AuthenticatedUser;
    readonly organizations: readonly Organization[];
    readonly swapOrgAuth: (input: {
        organizationId: string;
        name: string;
    }) => void;
    readonly swapOrgAuthLoading: boolean;
}

export const AccountMenu = ({
    user: authUser,
    organizations,
    swapOrgAuth,
    swapOrgAuthLoading,
}: IAccountMenu) => {
    const { user, organization: currentOrganization } = authUser;
    const logout = useLogout();

    return (
        <AuthedHeaderAccountMenu
            user={{
                img: unwrapMaybe(user.img),
                firstName: user.firstName || undefined,
                lastName: user.lastName || undefined,
                email: user.email,
                organizationImg: unwrapMaybe(currentOrganization?.img),
                organizationName: currentOrganization?.name || undefined,
                // TODO: show Owner role if user is an owner
                role: undefined,
            }}
            onClickLogout={() => logout()}
            content={
                <>
                    <Typography
                        variant="body3"
                        fontWeight="semibold"
                        textColor="disabled.onContainer"
                        sx={{
                            padding: 2,
                        }}
                    >
                        Switch account
                    </Typography>
                    <Stack gap={1} sx={{ padding: 2 }}>
                        {organizations?.map((organization) => (
                            <CellItem
                                disabled={swapOrgAuthLoading}
                                key={organization.name}
                                startNode={
                                    <CompanyAvatar
                                        color={
                                            swapOrgAuthLoading
                                                ? "disabled"
                                                : "primary"
                                        }
                                        size="sm"
                                        src={unwrapMaybe(organization.img)}
                                        alt={organization.name}
                                    />
                                }
                                endNode={
                                    <Radio
                                        disabled={swapOrgAuthLoading}
                                        checked={
                                            currentOrganization?.id ===
                                            organization.id
                                        }
                                    />
                                }
                                title={organization.name}
                                onClick={() => {
                                    swapOrgAuth({
                                        organizationId: organization.id,
                                        name: organization.name,
                                    });
                                }}
                                sx={{
                                    padding: 2,
                                }}
                            />
                        ))}
                    </Stack>
                </>
            }
        />
    );
};
